module.exports = __webpack_public_path__ + "media/landing_work/home/images/bullets-daec3b1a47b97a985ff92eabe271ece6.svg";